import React from "react";
import { Navigate } from "react-router-dom";
import { lazy } from "react";
import { isAuthenticated } from "../helpers/auth-helper";

const Authmiddleware = (props) => {
  if (!isAuthenticated()) {
    return (
      <Navigate to={{ pathname: "/home", state: { from: props.location } }} replace />
    );
  }

  return <>{props.children}</>;
};

export default Authmiddleware;